export default __webpack_public_path__ + "static/media/error_password.c12af715.svg";